import 'css-chunk:src/app/containers/Home/CommunitiesView/ProgramsDetailView/ProgramDetails.scss';export default {
  "ProgramDetails": "_ProgramDetails_1wybf_1",
  "menu": "_menu_1wybf_1"
};